// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inline crop UI inside Edit Avatar card — same size/theme; no second overlay. */

.avatar-crop-inline {
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: 100%;
  min-height: 0;
}

.avatar-crop-inline__hint {
  flex-shrink: 0;
  margin: 0;
}

.avatar-crop-inline__stage {
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  min-height: 280px;
  height: min(42vh, 360px);
  border-radius: 14px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

body.light_theme .avatar-crop-inline__stage {
  background: #0f172a;
  border-color: #e2e8f0;
}

.avatar-crop-inline__stage .reactEasyCrop_Container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.avatar-crop-inline__controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
}

.avatar-crop-inline__control {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.avatar-crop-inline__label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}

body.light_theme .avatar-crop-inline__label {
  color: #64748b;
}

.avatar-crop-inline__control input[type="range"] {
  width: 100%;
  height: 6px;
  accent-color: #d1aa67;
  cursor: pointer;
}

/* WebKit track/thumb — golden to match AGCX theme */
.avatar-crop-inline__control input[type="range"]::-webkit-slider-runnable-track {
  height: 6px;
  border-radius: 999px;
  background: rgba(209, 170, 103, 0.28);
}

body.light_theme .avatar-crop-inline__control input[type="range"]::-webkit-slider-runnable-track {
  background: rgba(209, 170, 103, 0.35);
}

.avatar-crop-inline__control input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  margin-top: -6px;
  border-radius: 50%;
  background: #d1aa67;
  border: 2px solid #f5ebda;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.avatar-crop-inline__control input[type="range"]::-moz-range-track {
  height: 6px;
  border-radius: 999px;
  background: rgba(209, 170, 103, 0.28);
}

body.light_theme .avatar-crop-inline__control input[type="range"]::-moz-range-track {
  background: rgba(209, 170, 103, 0.35);
}

.avatar-crop-inline__control input[type="range"]::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #d1aa67;
  border: 2px solid #f5ebda;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.avatar-crop-inline__chip {
  align-self: flex-start;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  color: #cbd5e1;
  border-radius: 999px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.avatar-crop-inline__chip:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
}

.avatar-crop-inline__chip:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

body.light_theme .avatar-crop-inline__chip {
  border-color: #cbd5e1;
  background: #f1f5f9;
  color: #334155;
}

body.light_theme .avatar-crop-inline__chip:hover:not(:disabled) {
  background: #e2e8f0;
}

/* When cropping, body uses flex so stage can fill remaining card height */
.settings-modal--avatar.settings-modal--avatar-cropping .settings-modal__body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.settings-modal--avatar.settings-modal--avatar-cropping .avatar-crop-inline {
  flex: 1 1;
  min-height: 0;
}

@media (max-width: 991px) {
  .avatar-crop-inline__stage {
    min-height: 220px;
    height: min(38vh, 300px);
  }
}

@media (max-width: 580px) {
  .avatar-crop-inline {
    gap: 10px;
  }

  .avatar-crop-inline__stage {
    min-height: 200px;
    height: min(36vh, 260px);
    border-radius: 12px;
  }
}

@media (max-height: 700px) {
  .avatar-crop-inline__hint {
    display: none;
  }

  .avatar-crop-inline__stage {
    min-height: 180px;
    height: min(34vh, 240px);
  }

  .avatar-crop-inline__controls {
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/SettingsPage/AvatarCropModal.css"],"names":[],"mappings":"AAAA,iFAAiF;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":["/* Inline crop UI inside Edit Avatar card — same size/theme; no second overlay. */\n\n.avatar-crop-inline {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  height: 100%;\n  min-height: 0;\n}\n\n.avatar-crop-inline__hint {\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.avatar-crop-inline__stage {\n  position: relative;\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 280px;\n  height: min(42vh, 360px);\n  border-radius: 14px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .avatar-crop-inline__stage {\n  background: #0f172a;\n  border-color: #e2e8f0;\n}\n\n.avatar-crop-inline__stage .reactEasyCrop_Container {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.avatar-crop-inline__controls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.avatar-crop-inline__control {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.avatar-crop-inline__label {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\nbody.light_theme .avatar-crop-inline__label {\n  color: #64748b;\n}\n\n.avatar-crop-inline__control input[type=\"range\"] {\n  width: 100%;\n  height: 6px;\n  accent-color: #d1aa67;\n  cursor: pointer;\n}\n\n/* WebKit track/thumb — golden to match AGCX theme */\n.avatar-crop-inline__control input[type=\"range\"]::-webkit-slider-runnable-track {\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(209, 170, 103, 0.28);\n}\n\nbody.light_theme .avatar-crop-inline__control input[type=\"range\"]::-webkit-slider-runnable-track {\n  background: rgba(209, 170, 103, 0.35);\n}\n\n.avatar-crop-inline__control input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  margin-top: -6px;\n  border-radius: 50%;\n  background: #d1aa67;\n  border: 2px solid #f5ebda;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n\n.avatar-crop-inline__control input[type=\"range\"]::-moz-range-track {\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(209, 170, 103, 0.28);\n}\n\nbody.light_theme .avatar-crop-inline__control input[type=\"range\"]::-moz-range-track {\n  background: rgba(209, 170, 103, 0.35);\n}\n\n.avatar-crop-inline__control input[type=\"range\"]::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #d1aa67;\n  border: 2px solid #f5ebda;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n\n.avatar-crop-inline__chip {\n  align-self: flex-start;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.06);\n  color: #cbd5e1;\n  border-radius: 999px;\n  padding: 7px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.avatar-crop-inline__chip:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.avatar-crop-inline__chip:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\nbody.light_theme .avatar-crop-inline__chip {\n  border-color: #cbd5e1;\n  background: #f1f5f9;\n  color: #334155;\n}\n\nbody.light_theme .avatar-crop-inline__chip:hover:not(:disabled) {\n  background: #e2e8f0;\n}\n\n/* When cropping, body uses flex so stage can fill remaining card height */\n.settings-modal--avatar.settings-modal--avatar-cropping .settings-modal__body {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.settings-modal--avatar.settings-modal--avatar-cropping .avatar-crop-inline {\n  flex: 1;\n  min-height: 0;\n}\n\n@media (max-width: 991px) {\n  .avatar-crop-inline__stage {\n    min-height: 220px;\n    height: min(38vh, 300px);\n  }\n}\n\n@media (max-width: 580px) {\n  .avatar-crop-inline {\n    gap: 10px;\n  }\n\n  .avatar-crop-inline__stage {\n    min-height: 200px;\n    height: min(36vh, 260px);\n    border-radius: 12px;\n  }\n}\n\n@media (max-height: 700px) {\n  .avatar-crop-inline__hint {\n    display: none;\n  }\n\n  .avatar-crop-inline__stage {\n    min-height: 180px;\n    height: min(34vh, 240px);\n  }\n\n  .avatar-crop-inline__controls {\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
